import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const CTA = () => {
  const navigate = useNavigate();

  return (
    <section id="cta" className="py-32 md:py-40 px-6 border-t border-ink/5 relative overflow-hidden">
      <div className="absolute inset-0 bg-lime/5"></div>
      
      <div className="max-w-4xl mx-auto text-center relative z-10 bg-white rounded-[2.5rem] border border-ink/10 shadow-saas px-8 py-20 md:px-20">
        <div className="absolute -top-12 -right-12 w-48 h-48 bg-lime/30 blur-[60px] rounded-full pointer-events-none"></div>
        <div className="absolute -bottom-12 -left-12 w-48 h-48 bg-lime/20 blur-[60px] rounded-full pointer-events-none"></div>

        <h2 className="text-4xl md:text-6xl font-bold tracking-tight mb-10 text-ink leading-tight relative z-10">
          Start your{' '}
          <span className="highlighter px-2">governance review.</span>
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 mb-10 items-center justify-center text-ink relative z-10">
          <p className="text-2xl md:text-3xl font-bold px-4 py-2 bg-ink text-white rounded-xl transform -rotate-2 shadow-md">
            Stop guessing.
          </p>
          <p className="text-2xl md:text-3xl font-bold px-4 py-2 bg-lime text-ink rounded-xl transform rotate-2 shadow-md">
            Start improving.
          </p>
        </div>

        <p className="text-xl text-ink/60 mb-12 max-w-2xl mx-auto leading-relaxed font-medium relative z-10">
          Conduct a consultant-level governance review internally and build a stronger,
          more effective organisation with GovernWell.
        </p>

        <button
          onClick={() => navigate('/health-check')}
          data-testid="cta-start-btn"
          className="bg-ink text-cream hover:bg-ink/90 rounded-full px-10 py-5 text-lg font-bold inline-flex items-center gap-3 justify-center transition-all active:scale-95 shadow-xl hover:shadow-2xl relative z-10"
        >
          Assess Your Governance Health <ArrowRight className="w-6 h-6 text-lime" />
        </button>
      </div>
    </section>
  );
};

export default CTA;
